<template>
  <div class="aha-input-group">
    <slot />
  </div>
</template>

<script>
export default {
  model: {
  },
  props: {
  },
}
</script>

<style lang="scss" scoped>
.aha-input-group {
  @apply flex items-stretch rounded box-border;

  .aha-input-prepend {
    @apply flex items-center justify-center;
    @apply w-10 h-10;
    @apply border-secondary-20 bg-primary-20 text-base-80;
    @apply border-t border-b border-l rounded-l;
  }
}

.aha-input-group:focus-within {
  .aha-input-prepend {
    @apply border-primary-90;
  }
}

.aha-input-group:hover {
  .aha-input-prepend {
    @apply border-primary-90;
  }
}

</style>
